/**
 *    @author: Andrew Sheen
 *    @since: 2021-01-20
 *
 */

import { Component, AfterViewInit, OnInit } from '@angular/core';
import { Router } from '@angular/router'; 
import { TimerService } from 'src/refresh/service/timer-service';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { InputData, ParentInfo } from '../_common/data/input-data';
import { Path, Progress } from  "../_common/constant/page-const";
import { AboutTheParentsMainValidation } from './about_the_parents_main.validator';
import { ItemList } from '../_common/constant/item-list';
import { Confirm } from 'src/refresh/service/constant';
import { ViewportScroller } from '@angular/common';
import { ProgressService } from 'src/refresh/service/progress-service';

@Component({ 
      selector: 'about_the_parents_main',
      templateUrl: './about_the_parents_main.component.html',
      styleUrls: ['./about_the_parents_main.component.less']
      
})
export class AboutTheParentsMainComponent extends FormBaseComponent implements OnInit {

       public parents:ParentInfo[];

       public parentCount:number;
       public certyfyingCount:number;
       public parentCntParam:Object;

       public childNameParam:Object;
       public isSurrogate:boolean;
       public isUnableToCertify:boolean;
       public isCertifiedDisable:boolean;
       public isCustodyOtherThanParent:boolean;
       public errors:ErrorOfName[];

       public selectedParent:number = -1;

       public error_parent2:string = "";
       public error_parent3:string = "";

       public isNoGiveBirth:boolean;

       private isCertifyingParent:string[] = [];

       constructor( protected router: Router ,
                    public timerService:TimerService,
                    protected progress:ProgressService,
                    public items:ItemList,
                    public data:InputData,
                    viewportScroller: ViewportScroller ) {

                    super(router,timerService);  

                    super.setNextPage(Path.AboutTheParentsScreen1,Path.AboutTheChildScreen2);
                    super.setValidator(new AboutTheParentsMainValidation(this,viewportScroller,Progress.AboutParent));

                    //-------------------------
                    this.setLocalFieldFromData(data);
                    //-------------------------
                    this.initErrors();
                    this.setSelectedParentForCertify();
                    
                    this.childNameParam = { childName: data.aboutChild.name.getFullName()  };
                    this.parentCntParam = { parentCnt : items.parentCnt.get(this.parentCount)};

                    this.isCustodyOtherThanParent = this.data.eligibility.isCustodyOtherThanParent == Confirm.YES;
                    

                    if ( this.parentCount == 1 ) {            // no agree radio in child form.
                         if ( !this.isSurrogate ) this.parents[0].isGiveBirth = Confirm.YES;
                    }

                    if ( !this.isCustodyOtherThanParent && this.parentCount == 1 ) 
                          data.aboutChild.isParentAgreeOnLastName = Confirm.YES;
                    
                    let agreed =  ( data.aboutChild.isParentAgreeOnLastName == Confirm.YES  ||
                                    data.aboutChild.isParentAgreeOnSingleName == Confirm.YES );

                    if ( this.isCustodyOtherThanParent )  agreed = false;

                    let certified = Confirm.YES;
                    if ( this.isCustodyOtherThanParent || this.isUnableToCertify ) certified = Confirm.NO;

                    for ( let i = 0; i < this.parents.length; i++ ) {
                          this.parents[i].isLastNameAgreed   =  agreed;  
                          if ( !this.isCustodyOtherThanParent ) 
                               this.parents[i].isLastNameLocked   = !agreed;
                          else this.parents[i].isLastNameLocked   = false;

                          if ( !this.isUnableToCertify ) 
                                this.parents[i].isCertifyingParent = certified;
                    }
                                
                    this.isCertifiedDisable = false;      

                    if ( this.isUnableToCertify ) {
                         if ( !agreed ) {
                              this.isCertifiedDisable = true;      
                              for ( let i = 0; i < this.certyfyingCount; i++ ) {
                                    this.parents[i].isCertifyingParent = Confirm.YES;  
                                    this.parents[i].isLastNameLocked   = true;  
                              }
                                    
                              for ( let i = this.certyfyingCount; i < this.parents.length; i++ )  {
                                    this.parents[i].isLastNameLocked = false;  
                              }
                         }
                    }

                    this.parents.forEach( (p) => {
                         this.isCertifyingParent.push( p.isCertifyingParent );
                    });

                    InputData.currentPageIdx = 10;
                    if ( InputData.moveNext == 0 || InputData.moveNext == InputData.currentPageIdx ) this.timerService.isForwarding = false;
       }

       private setLocalFieldFromData(data:InputData) {
                    this.parentCount = data.eligibility.listedParentCount;
                    this.parents     = data.parents;  
                    this.isSurrogate = data.eligibility.isBornThroughSurrogacy==Confirm.YES;

                    this.isUnableToCertify = data.eligibility.isUnableToCertify==Confirm.YES;
                    this.certyfyingCount   = data.eligibility.certifyingParentCount;
       }


       private initErrors() {
                    this.errors = new Array<ErrorOfName>(this.parentCount);
                    for ( let i = 0; i < this.parentCount; i++ ) {
                          this.errors[i] = new ErrorOfName();
                    }
       }

       public ngOnInit() {

              if ( super.forwardNext(InputData.currentPageIdx) ) return;
              
              if ( this.isSurrogate == false ) {
                   for ( let i = 0; i < this.parentCount; i++ ) {
                         if ( this.parents[i].isGiveBirth != Confirm.NO ) return;
                   } 
                   this.isNoGiveBirth = true;
              }
              else {
                    for ( let i = 0; i < this.parentCount; i++ ) {
                          this.parents[i].isGiveBirth = "";
                    } 
              }  
       }

       public onNextClick() : boolean  {
              this.createParentList();
              this.checkCertifyingParentChange();

              /**
              //console.log("----- CERT / AGREED / GIVE_BIRTH ---")
              //for ( let i = 0; i < this.parents.length; i++ )   
              //   console.log(i,this.parents[i].isCertifyingParent,
              //                 this.parents[i].isLastNameAgreed,
              //                 this.parents[i].isGiveBirth);
                                */
              return super.onNextClick();
       } 

       private checkCertifyingParentChange() {

               for ( let i = 0; i < this.parentCount; i++ ) {
                     if ( this.isCertifyingParent[i] !=  this.parents[i].isCertifyingParent ) { 
                          this.data.orderOfBC.applicantIndex = -1;
                          this.data.CCB.primaryCaregiver = -1;
                          this.data.CCB.careGiver = "";
                          this.data.CESP.contactParent = -1;
                          return;
                     }
               }
       }

       private createParentList() {
             
              let  motherIdx:number = this.data.getBirthParentIndex();

              //---- MotherFirstList
              let  idx = 1;
              if ( motherIdx >= 0 )
                   this.data.parentList[0] = this.parents[motherIdx];
              else idx = 0;

              for ( let i = 0; i < this.parentCount; i++ ) {
                    if ( motherIdx == i ) continue;
                    this.data.parentList[idx++] = this.parents[i];
              }

              //---------------------------------------------------------------------------------
              this.data.certifyingParents.clear();

              ///console.log("motherIdx",motherIdx, this.parents[motherIdx].isCertifyingParent);

              if ( motherIdx >= 0 && this.parents[motherIdx].isCertifyingParent=='Y' ) {
                   this.data.certifyingParents.set(motherIdx,this.parents[motherIdx].name.getFullName());
              }
              else motherIdx = -1;
              
              for ( let i = 0; i < this.parentCount; i++ ) {
                    if ( i == motherIdx ) continue;
                    if ( this.parents[i].isCertifyingParent == Confirm.YES ) {
                         this.data.certifyingParents.set(i,this.parents[i].name.getFullName());
                    }
              }

              //this.data.certifyingParents.forEach( (value,key) => {
              //           console.log( "====>", key,value );
              //});
       }

       //=================================================================================
       public onGiveBirthChange(index) {

              this.isNoGiveBirth = false;

              if ( this.parents[index].isGiveBirth == Confirm.YES ) {
                   for ( let i = index+1; i < this.parentCount; i++ ) {
                         this.parents[i].isGiveBirth = "";
                         this.errors[i].giveBirth = "";
                   } 
              }
              else
              if ( this.parents[index].isGiveBirth == Confirm.NO ) {
                   if ( (index+1) >= this.parentCount ) {
                         this.isNoGiveBirth = true;
                   }
              }
       }

       public onSingleNameChange(index) {

              if ( this.parents[index].name.chk_singleName != Confirm.YES ) {
                   this.parents[index].isASNOpen= false;
                   if ( this.parents[index].isLastNameAgreed == false ) {
                        this.parents[index].name.last = this.parents[index].name.single;
                   } 
                   this.parents[index].name.single = "";
              }
              else {
                   this.parents[index].isASNOpen = true;
                   if ( this.parents[index].isLastNameAgreed == false ) {
                        this.parents[index].name.single = this.parents[index].name.last;
                   } 
                   this.parents[index].name.last = "";
                   this.parents[index].name.first = "";
                   this.parents[index].name.middle = "";
                   this.parents[index].name.chk_middleNA = false;
              }
              
              this.errors[index].firstName  = "";    
              this.errors[index].middleName = "";    
              this.errors[index].lastName   = "";    
              this.errors[index].singleName   = "";    
       }

       // @see onCertifyingParent2Change() 
       private setSelectedParentForCertify() {

              if ( this.certyfyingCount == 1 ) {
                    for ( let i = 0; i < this.parentCount; i++ ) {
                          if ( this.parents[i].isCertifyingParent == Confirm.YES ) {
                               this.selectedParent = i;
                               return;
                          }
                    }
               }     
       }

       public onCertifyingParent2Change() {  // for radio select change  case: this.certyfyingCount == 1

              let selected:number = this.selectedParent;
              for ( let i = 0; i < this.parentCount; i++ ) {
                    if  ( i == selected ) { 
                          this.parents[i].isCertifyingParent = Confirm.YES;
                    }
                    else  this.parents[i].isCertifyingParent = Confirm.NO;
              }
       }
}

export class ErrorOfName {
       public firstName:string;
       public middleName:string;
       public lastName:string;
       public singleName:string;
       public giveBirth:string;
}